export const SET_TRAINING = "SET_TRAINING";
export const CREATE_TRAINING = "CREATE_TRAINING";
export const TRAININGS_RECEIVED = "TRAININGS_RECEIVED";
export const SET_PROPERTY_TRAINING = "SET_PROPERTY_TRAINING";
